import { Component, type ReactNode } from 'react';

type Props = {
  af: string;
  primaryAf: string;
  render: (effectiveAf: string, fellBack: boolean) => ReactNode;
};

type State = { errored: boolean };

export default class SatelliteFallbackBoundary extends Component<Props, State> {
  state: State = { errored: false };

  static getDerivedStateFromError(): State {
    return { errored: true };
  }

  componentDidUpdate(prev: Props) {
    if (prev.af !== this.props.af && this.state.errored) {
      this.setState({ errored: false });
    }
  }

  componentDidCatch(err: unknown) {
    console.error('[SatelliteFallback] caught render error for', this.props.af, err);
  }

  render() {
    const isSatellite = this.props.af !== this.props.primaryAf;
    if (this.state.errored && isSatellite) {
      return this.props.render(this.props.primaryAf, true);
    }
    return this.props.render(this.props.af, false);
  }
}
